import { motion } from 'framer-motion';
import history from '@history';
import Box from '@mui/material/Box';
import { Button, Typography } from '@mui/material';
import { useCallback } from 'react';
import { defaultLoginRedirect, defaultLogoutRedirect } from 'src/app/configs/settingsConfig';
import { useSelector } from 'react-redux';

export const Error404Page = () => {
  const { token } = useSelector((state) => state.auth);

  const redirectDefault = useCallback(() => {
    history.replace(token ? defaultLoginRedirect : defaultLogoutRedirect);
  }, [token]);

  return (
    <div className="flex flex-col flex-1 items-center justify-center h-full">
      <div className="w-full max-w-3xl text-center mx-auto">
        <motion.div
          initial={{ opacity: 0, scale: 0.6 }}
          animate={{ opacity: 1, scale: 1, transition: { delay: 0.1 } }}
        >
          <Box width="100%" height="100%" className="flex justify-center items-center">
            <img
              src="/assets/images/error/error-001.svg"
              alt="Logo"
              className="mx-auto"
              style={{ width: '35%', height: '20%', aspectRatio: '1' }}
            />
          </Box>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0, transition: { delay: 0.2 } }}
        >
          <Typography
            color="primary"
            className="mt-24 sm:mt-32 text-4xl md:text-7xl font-extrabold tracking-tight leading-tight md:leading-none text-center"
          >
            404
          </Typography>
        </motion.div>
        <Button
          sx={{ color: 'primary.main' }}
          onClick={() => redirectDefault()}
          onTouchEnd={() => redirectDefault()}
        >
          <Typography
            color="primary"
            className="block text-2xl font-semibold mt-16 sm:mt-24 text-center"
          >
            VOLVER a la Página Principal
          </Typography>
        </Button>
      </div>
    </div>
  );
};
